import { lazy } from 'react';
import { type RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

import SearchParamsGuard from './SearchParamsGuard';

const routes: RouteObject[] = [
  {
    path: 'deployment',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: () => (
          <SearchParamsGuard
            configs={[
              {
                prefix: 'modeling',
                limit: 10,
                offset: 0,
              },
            ]}
          />
        ),
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/deployment/DeploymentPage')),
          },
        ],
      },
    ],
  },
];

export default routes;
